
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import apiClient from '../api/axios';
import { useAuth } from '../contexts/AuthContext';

const AcceptInvitationPage = () => {
    const { token } = useParams();
    const navigate = useNavigate();
    const { user, isAuthenticated } = useAuth();
    const [message, setMessage] = useState('Принимаем приглашение...');
    const [error, setError] = useState(false);

    useEffect(() => {
        if (isAuthenticated) {
            apiClient.post(`/invitations/accept/${token}`)
                .then(response => {
                    setMessage('Вы успешно присоединились к организации!');
                    setTimeout(() => {
                        navigate(`/organization/${response.data.organization_id}`);
                    }, 2000);
                })
                .catch(err => {
                    setError(true);
                    if (err.response && err.response.data && err.response.data.detail) {
                        setMessage(err.response.data.detail);
                    } else {
                        setMessage('Произошла ошибка при принятии приглашения.');
                    }
                });
        } else {
            setError(true);
            setMessage('Вам нужно войти в систему, чтобы принять приглашение.');
        }
    }, [token, isAuthenticated, navigate]);

    return (
        <div className="container mt-5">
            <div className={`alert ${error ? 'alert-danger' : 'alert-success'}`}>
                {message}
            </div>
        </div>
    );
};

export default AcceptInvitationPage;
